import { render, staticRenderFns } from "./PurchaseInvoicesReportsFiltersForm.vue?vue&type=template&id=4b4a1adc&scoped=true&"
import script from "./PurchaseInvoicesReportsFiltersForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesReportsFiltersForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoicesReportsFiltersForm.vue?vue&type=style&index=0&id=4b4a1adc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a1adc",
  null
  
)

export default component.exports